<script>
import { loaded, ToneAudioBuffer } from "tone";
import {onMount} from "svelte";
let loading = true;
let dots = 0;


function dotLoop() {
    if (loading) {
        dots = (dots + 1) % 4;
        setTimeout(() => {
            dotLoop();
        }, 500);
    }
}

onMount(() => {
    loading = ToneAudioBuffer.downloads.length > 0;

    if (loading) {
        loaded().then(() => {
            loading = false;
        });
        dotLoop();
    }
});

</script>

<div id="container" loading={loading}>
    <div id="text">{loading ? `loading ${dots}` : 'Done!'}</div>
</div>

<style>

    #container {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(55, 55, 55, 0.5);
        z-index: 10000000;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        pointer-events: none;
        transition: opacity 0.2s;
        opacity: 0;
    }
    #container[loading="true"] {
        opacity: 1;
    }

    #text {
        position: absolute;
        top: 50%;
        left: 50%;
        color: white;
        font-size: 2em;
        width: 100px;
        transform: translate(-50%, -50%);
    }
</style>